import { createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../../api/services/auth";
import { LOGOUT } from "../../../utils/constants";

export const sendCode = createAsyncThunk(
  "auth/sendCode",
  async (requestData) => {
    return await authService.sendCode(requestData);
  }
);

export const refresh = createAsyncThunk("auth/refresh", async () => {
  return await authService.refresh();
});

export const logout = createAsyncThunk("auth/logout", async (_, thunkAPI) => {
  thunkAPI.dispatch({ type: LOGOUT });
  return await authService.logout();
});

export const verifyEmail = createAsyncThunk(
  "auth/verify-email",
  async (requestData) => {
    return await authService.verifyEmail(requestData);
  }
);
